class ElementPicker extends HTMLElement {
  constructor() {
    super();

    this.selectedImage = this.querySelector('.selected-image');
    this.imageModal = this.querySelector('.image-modal');
    this.closeButton = this.querySelector('.close');
    this.datePicker = this.querySelector('.date-picker');
    this.index = this.dataset.index;
    this.input = document.querySelector(`#select-element-data-${this.index}`);

    this.handleEvents.bind(this)();

  }

  dispatchUpdate() {
    const event = new CustomEvent('calendar:updated', {
      detail: {
        element: this.input.value,
        index: this.index
      }
    });
    document.dispatchEvent(event);
  }

  handleEvents() {
    this.selectedImage.addEventListener('click', this.openModal.bind(this));
    this.closeButton.addEventListener('click', this.closeModal.bind(this));
    this.imageModal.addEventListener('click', (e) => {
      if (e.target.tagName === 'IMG') {
        this.updateElement(e.target);
        this.dispatchUpdate();
      }
    });
    
    const dateSelectedEvent = this.datePicker ? `dateSelected-${this.datePicker.dataset.instance}` : 'dateSelected-moon-phase-finder--1';
    document.addEventListener(dateSelectedEvent, async (e) => {
      const date = e.detail.date; // "20-1-2025"
      const day = Number(date.split('-')[0]);
      const month = Number(date.split('-')[1]);
      const zodiacObj = MoonCalculator.getZodiacElementFromDate(day, month);
      this.updateElementFromDate(zodiacObj);
    });
  }
  
  updateElementFromDate(zodiacObj) {
    const elementName = this.querySelector('.element-name');

    this.updateInputValue(zodiacObj.zodiacSign, zodiacObj.element);
    elementName.innerHTML = `<span>${zodiacObj.element}</span> | <span>${zodiacObj.zodiacSign}</span>`;
    elementName.classList.remove('default');
    const targetImage = this.querySelector(`img[data-element="${zodiacObj.element.toLowerCase()}-${zodiacObj.zodiacSign.toLowerCase()}"]`);
    this.updateElementImage(targetImage);
  };

  updateElementImage(targetImage) {
    const selectedImage = this.selectedImage.querySelector('img');
    selectedImage.src = targetImage.src; // Update the `src` dynamically
    selectedImage.srcset = targetImage.srcset; // Update the `srcset` dynamically
    selectedImage.alt = targetImage.alt; // Update the `alt` dynamically
    selectedImage.dataset.label = targetImage.dataset.label; // Update the `dataset` dynamically
    selectedImage.dataset.element = targetImage.dataset.element; // Update the `dataset` dynamically
  }

  capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  updateInputValue(label, element) {
    this.input.value = `${this.capitalize(label)} / ${this.capitalize(element)}`;
  }

  updateElement(targetImage) {
    const elementName = this.querySelector('.element-name');
    const element = targetImage.dataset.element.split('-')[1].toLowerCase();
    const label = targetImage.dataset.label;

    this.updateInputValue(label, element);

    elementName.innerHTML = `<span>${label}</span> | <span>${element.toLowerCase()}</span>`;
    elementName.classList.remove('default');

    this.updateElementImage(targetImage);
    this.closeModal();
  }

  closeImageModals() {
    const imageModals = document.querySelectorAll('.image-modal');
    imageModals.forEach(modal => {
      if (modal.classList.contains('active') && modal !== this.imageModal) {
        modal.classList.remove('active');
      }
    });
  }

  openModal() {
    this.closeImageModals();
    this.imageModal.classList.add('active');
  }

  closeModal() {
    this.imageModal.classList.remove('active');
  }
}

if (!customElements.get('elements-picker')) customElements.define('elements-picker', ElementPicker);